export const IsAdminMode = () => {
  return process.env.ADMIN_MODE ?? false;
};
